const user = {
    state: {
        player: null, //播放器实例
        curPlay: '', //当前播放视频id
        playtime: "0", //当前已播放时间
        palyObj: null, //当前播放对象
        chapterList: [],//章节列表
        heartbeatTime: 15,//心跳时间
        timer:null,//定时器
        isPlay:false,//是否正在播放
    },
    mutations: {
        updateplayer(state, data) {
            state.player = data;
        },
        updatecurPlay(state, data) {
            state.curPlay = data;
        },
        updateplaytime(state, data) {
            state.playtime = data;
        },
        updateheartpalyObj(state, data) {
            state.palyObj = data;
        },
        updatechapterList(state, data) {
            state.chapterList = data;
        },
        updateheartbeatTime(state, data) {
            state.heartbeatTime = data;
        },
        updateTimer(state, data) {
            state.timer = data;
        },
        updateisPlay(state, data) {
            state.isPlay = data;
        },
    },
    actions: {
        updateplayer(context, data) {
            context.commit("updateplayer", data)
        },
        updatecurPlay(context, data) {
            context.commit("updatecurPlay", data)
        },
        updateplaytime(context, data) {
            context.commit("updateplaytime", data)
        },
        updateheartpalyObj(context, data) {
            context.commit("updateheartpalyObj", data)
        },
        updatechapterList(context, data) {
            context.commit("updatechapterList", data)
        },
        updateheartbeatTime(context, data) {
            context.commit("updateheartbeatTime", data)
        },
        updateTimer(context, data) {
            context.commit("updateTimer", data)
        },
        updateisPlay(context, data) {
            context.commit("updateisPlay", data)
        }
    }
}

export default user
